<template>
  <section>
    <div class="container">
      <b-card class="shadow p-3 mb-5 bg-white rounded m-4">
        <b-row>
          <b-col cols="4">
            <b-link class="text-left h4" to="/dashboard"><b-icon icon="arrow-left-circle"></b-icon> Kembali</b-link>
          </b-col>
          <b-col cols="4">
            <b-card-title class="text-center h3">{{ updateSubmit ? 'Edit' : 'Tambah' }} Produk</b-card-title>
          </b-col>
        </b-row>
        <b-card-body>
          <div v-if="isLoading" class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
            <p class="mt-3">Memuat data...</p>
          </div>
          <div v-else>
            <b-alert v-if="!showForm" show variant="danger">
              Form tidak dapat ditampilkan karena masalah dengan data produk. Silakan cek ulang atau hubungi administrator.
            </b-alert>
            <b-alert v-if="nisbahError" show variant="danger" dismissible @dismissed="nisbahError = ''">
              {{ nisbahError }}
            </b-alert>
            <b-alert v-if="equalRateError" show variant="danger" dismissible @dismissed="equalRateError = ''">
              {{ equalRateError }}
            </b-alert>
            <ValidationObserver v-if="showForm" v-slot="{ handleSubmit }">
              <b-form @submit.prevent="handleSubmit(addProduct)">
                <b-form-group>
                  <label>Nama Produk<span class="text-danger"> *</span></label>
                  <ValidationProvider name="nama produk" rules="required" v-slot="{ errors }">
                    <b-form-input type="text" v-model="form.nama_produk" required
                      placeholder="Masukan nama produk"></b-form-input>
                    <span class="text-danger">{{ errors[ 0 ] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group>
                  <label>Kategori Produk<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.product_category_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in options.category" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group>
                  <label>Sub Kategori Produk<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.sub_product_category_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in filteredSubCategories" :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group>
                  <label>Jenis Akad<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.akad_id" @input="jenisAkadChange" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in filteredAkadOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <!-- <b-form-group>
                  <label>Nisbah Bagi Hasil<span class="text-danger"> *</span></label>
                  <b-form-select :disabled="disabled == 0" v-model="form.nisbah" :required="form.akad_id == 1">
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in options.nisbah" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group> -->

                <!-- <b-form-group>
                  <label>Nisbah Bagi Hasil<span class="text-danger"> *</span></label>
                  <ValidationProvider name="nisbah" rules="required" v-slot="{ errors }">
                    <b-form-input type="text" v-model="form.nisbah" required placeholder="Nisbah (Ex: 45:55)"></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group> -->

                <b-form-group>
                  <div class="row">
                    <!-- Nisbah Bagi Hasil -->
                    <div class="col-md-6">
                      <label>Nisbah Bagi Hasil (%)<span class="text-danger"> *</span></label>
                      <ValidationProvider name="nisbah bagi hasil" :rules="nisbahRules" v-slot="{ errors }">
                        <div class="d-flex align-items-center">
                          <b-form-input type="number" v-model="nisbah_bagi_hasil_part1" placeholder="Contoh: 45"
                            :disabled="form.akad_id === 2" class="mr-2"></b-form-input>
                          <span>:</span>
                          <b-form-input type="number" v-model="nisbah_bagi_hasil_part2" placeholder="Contoh: 55"
                            class="ml-2" disabled></b-form-input>
                        </div>
                        <small class="text-danger">{{ errors[ 0 ] }}</small>
                      </ValidationProvider>
                    </div>

                    <!-- Proyeksi Bagi Hasil -->
                    <div class="col-md-6">
                      <label>Proyeksi Bagi Hasil (Equal Rate) p.a.<span class="text-danger"> *</span></label>
                      <ValidationProvider name="equal rate" :rules="nisbahRules" v-slot="{ errors }">
                        <div class="input-group">
                          <b-form-input type="number" :disabled="disabled === 0" step=".01" v-model="form.equal_rate"
                            placeholder="Masukkan Equal Rate"></b-form-input>
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <i class="fa fa-percent" aria-hidden="true"></i>
                            </span>
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[ 0 ] }}</small>
                      </ValidationProvider>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group>
                  <div class="row align-items-center">
                    <!-- Setoran Awal Minimum (Required) -->
                    <div class="col-md-5">
                      <label for="input-setoran-awal-minimum">Setoran Awal Minimal<span class="text-danger">
                          *</span></label>
                      <ValidationProvider name="min setoran awal" rules="required" v-slot="{ errors }">
                        <b-form-input id="input-setoran-awal-minimum" v-model="formattedSetoranAwalMinimum"
                          @input="updateSetoranAwalMinimum" type="text" placeholder="Masukkan Setoran Awal Minimal"
                          required></b-form-input>
                        <small class="text-danger">{{ errors[ 0 ] }}</small>
                      </ValidationProvider>
                    </div>

                    <!-- Separator s.d -->
                    <div class="col-md-1 text-center">
                      <span>s.d</span>
                    </div>

                    <!-- Setoran Awal Maksimal (opsional) -->
                    <div class="col-md-5">
                      <label for="input-setoran-awal-maximum">Setoran Awal Maksimal (opsional)</label>
                      <b-form-input id="input-setoran-awal-maximum" v-model="formattedSetoranAwalMaximum"
                        @input="updateSetoranAwalMaximum" type="text"
                        placeholder="Masukkan Setoran Awal Maksimal (Opsional)"></b-form-input>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group>
                  <label>Deskripsi<span class="text-danger"> *</span></label>
                  <ValidationProvider name="deskripsi" rules="required" v-slot="{ errors }">
                    <b-form-textarea placeholder="Masukan Deskripsi..." v-model="form.description" rows="3" required
                      max-rows="6"></b-form-textarea>
                    <span class="text-danger">{{ errors[ 0 ] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group label="Biaya administrasi (opsional)">
                  <b-form-input id="input-biaya-administrasi" v-model="formattedBiayaAdministrasi"
                    @input="updateBiayaAdministrasi" type="text" placeholder="Masukan Biaya administrasi"></b-form-input>
                </b-form-group>

                <b-form-group label="Biaya di bawah saldo minimum (opsional)">
                  <b-form-input id="input-biaya-dibawah-saldo-minimum" v-model="formattedBiayaDibawahSaldoMinimum"
                    @input="updateBiayaDibawahSaldoMinimum" type="text"
                    placeholder="Masukan Biaya di bawah saldo minimum"></b-form-input>
                </b-form-group>

                <b-form-group label="Biaya penutupan rekening (opsional)">
                  <b-form-input id="input-biaya-penutupan-rekening" v-model="formattedBiayaPenutupanRekening"
                    @input="updateBiayaPenutupanRekening" type="text"
                    placeholder="Masukan Biaya penutupan rekening"></b-form-input>
                </b-form-group>

                <b-form-group label="Biaya penarikan saldo sebelum jatuh tempo (opsional)">
                  <b-form-input id="input-biaya-penarikan-sebelum-jatuh-tempo"
                    v-model="formattedBiayaPenarikanSebelumJatuhTempo" @input="updateBiayaPenarikanSebelumJatuhTempo"
                    type="text" placeholder="Masukan Biaya penarikan saldo sebelum jatuh tempo"></b-form-input>
                </b-form-group>

                <b-form-group label="Biaya lain-lain (opsional)">
                  <div class="row">
                    <div class="col">
                      <b-form-input id="input-keterangan" v-model="form.keterangan" type="text"
                        placeholder="Masukan Keterangan"></b-form-input>
                    </div>
                    <div class="col">
                      <b-form-input id="input-biaya-lain-lain" v-model="formattedBiayaLainLain"
                        @input="updateBiayaLainLain" type="text"
                        placeholder="Masukan Nominal Biaya Lain Lain"></b-form-input>
                    </div>
                  </div>
                </b-form-group>

                <!-- <b-form-group>
                  <label>Jenis Funder<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.jenisnasabah_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in options.jenisNasabah" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group> -->

                <b-form-group v-if="form.product_category_id == 1">
                  <div class="row">
                    <div class="col">
                      <b-form-checkbox value="1" unchecked-value="0" v-model="form.syarat_kepemilikan_rekening">
                        Syarat kepemilikan rekening
                      </b-form-checkbox>
                    </div>
                    <div class="col">
                      <b-form-checkbox value="1" unchecked-value="0" v-model="form.automatic_roll_over">
                        Automatic Roll Over
                      </b-form-checkbox>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group v-if="form.product_category_id == 1 && form.syarat_kepemilikan_rekening == 1">
                  <label>Product Tabungan<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.product_tabungan_id" :required="form.syarat_kepemilikan_rekening == 1">
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in options.mitra_tabungan" :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group v-if="form.product_category_id == 1">
                  <label>Penarikan Bagi Hasil<span class="text-danger"> *</span></label>
                  <b-form-select class="mb-3" v-model="form.penarikan_bagi_hasil" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in options.penarikan_bagi_hasil" :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-button 
                  class="mt-4" 
                  block 
                  type="button" 
                  :disabled="isLoadSubmit"
                  @click="validateAndAddProduct" 
                  variant="primary"
                  v-if="!updateSubmit">
                  <b-spinner v-if="isLoadSubmit"></b-spinner>
                  <span v-else>Tambah</span>
                </b-button>

                <b-button 
                  class="mt-4" 
                  block 
                  type="button" 
                  :disabled="isLoadSubmit"
                  @click="updateData" 
                  variant="primary"
                  v-else>
                  <b-spinner v-if="isLoadSubmit"></b-spinner>
                  <span v-else>Simpan</span>
                </b-button>
              </b-form>
            </ValidationObserver>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <b-modal size="sm" v-model="confirmProductModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Apakah anda yakin ingin menambahkan produk ini?</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="confirmAddProduct">Ya</b-button>
        </div>
        <div class="col">
          <b-button class="mt-3" block @click="confirmProductModal = false">Tidak</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
      <div class="d-block text-center">
        <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
        <h3>{{ modalText }}</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="successConfirm">Tutup</b-button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import AkadSyariah from '../../api/akadsyariah';
import JenisNasabah from '../../api/jenisnasabah';
import Product from '../../api/produk';
import ProductCategory from '../../api/productcategory';
import SubProductCategory from '../../api/subproductcategory';
import Tilaka from '../../api/tilaka';

export default {
  name: 'ProductForm',
  data() {
    return {
      showForm: true,
      isLoading: false,
      isLoadSubmit: false,
      form: {
        id: null,
        mitra_id: null,
        nama_produk: '',
        description: '',
        product_category_id: '',
        sub_product_category_id: '',
        akad_id: '',
        nisbah: '',
        equal_rate: null,
        min_initial_deposit: null,
        max_initial_deposit: null,
        biaya_administrasi: null,
        biaya_dibawah_saldo_minimum: null,
        biaya_penutupan_rekening: null,
        biaya_penarikan_sebelum_jatuh_tempo: null,
        keterangan: null,
        biaya_lain_lain: null,
        jenisnasabah_id: 3,
        syarat_kepemilikan_rekening: 0,
        automatic_roll_over: 1,
        product_tabungan_id: '',
        penarikan_bagi_hasil: '',
        nisbah_bagi_hasil_part1: '',
        nisbah_bagi_hasil_part2: '',
      },
      options: {
        akad: [],
        jenisNasabah: [],
        category: [],
        sub_category: [],
        nisbah: [
          { text: '30:70', value: '30:70' },
          { text: '35:65', value: '35:65' },
          { text: '40:60', value: '40:60' },
          { text: '50:50', value: '50:50' },
          { text: '5:95', value: '5:95' },
          { text: '27:73', value: '27:73' },
        ],
        mitra_tabungan: [],
        penarikan_bagi_hasil: [
          { text: 'Tiap Bulan', value: 'tiap-bulan' },
          { text: 'Akhir Periode', value: 'akhir-periode' },
        ],
      },
      nisbah_bagi_hasil_part1: '',
      nisbah_bagi_hasil_part2: '',
      confirmProductModal: false,
      successModal: false,
      updateSubmit: false,
      modalText: '',
      currentUser: '',
      disabled: 1,
      paramsId: null,
      nisbahError: '',
      equalRateError: '',
    };
  },
  computed: {
    filteredAkadOptions() {
      if (this.form.product_category_id === 1) {
        // Jika kategori produk adalah 1, hanya tampilkan akad dengan value 1
        return this.options.akad.filter(option => option.value === 1);
      } else {
        // Jika kategori produk bukan 1, tampilkan semua opsi akad
        return this.options.akad;
      }
    },
    nisbahRules() {
      // Nisbah bagi hasil hanya required jika akad_id bukan 2
      return this.form.akad_id !== 2 ? "required" : "";
    },
    filteredSubCategories() {
      return this.options.sub_category.filter(
        (subcategory) => subcategory.product_category_id === this.form.product_category_id
      );
    },
    formattedSetoranAwalMinimum: {
      get() {
        return this.formatCurrency(this.form.min_initial_deposit);
      },
      set(value) {
        this.form.min_initial_deposit = this.parseCurrency(value);
      },
    },
    formattedSetoranAwalMaximum: {
      get() {
        return this.formatCurrency(this.form.max_initial_deposit);
      },
      set(value) {
        this.form.max_initial_deposit = this.parseCurrency(value);
      },
    },
    formattedBiayaAdministrasi: {
      get() {
        return this.formatCurrency(this.form.biaya_administrasi);
      },
      set(value) {
        this.form.biaya_administrasi = this.parseCurrency(value);
      },
    },
    formattedBiayaDibawahSaldoMinimum: {
      get() {
        return this.formatCurrency(this.form.biaya_dibawah_saldo_minimum);
      },
      set(value) {
        this.form.biaya_dibawah_saldo_minimum = this.parseCurrency(value);
      },
    },
    formattedBiayaPenutupanRekening: {
      get() {
        return this.formatCurrency(this.form.biaya_penutupan_rekening);
      },
      set(value) {
        this.form.biaya_penutupan_rekening = this.parseCurrency(value);
      },
    },
    formattedBiayaPenarikanSebelumJatuhTempo: {
      get() {
        return this.formatCurrency(this.form.biaya_penarikan_sebelum_jatuh_tempo);
      },
      set(value) {
        this.form.biaya_penarikan_sebelum_jatuh_tempo = this.parseCurrency(value);
      },
    },
    formattedBiayaLainLain: {
      get() {
        return this.formatCurrency(this.form.biaya_lain_lain);
      },
      set(value) {
        this.form.biaya_lain_lain = this.parseCurrency(value);
      },
    },
  },
  watch: {
    nisbah_bagi_hasil_part1(newVal) {
      if (this.form.akad_id != 2) {
        if (newVal > 100) {
          this.nisbah_bagi_hasil_part1 = 100;
        } else if (newVal < 0) {
          this.nisbah_bagi_hasil_part1 = 0;
        } else {
          this.nisbah_bagi_hasil_part2 = 100 - newVal;
        }
      }
    },
    nisbah_bagi_hasil_part2(newVal) {
      if (this.form.akad_id != 2) {
        if (newVal > 100) {
          this.nisbah_bagi_hasil_part2 = 100;
        } else if (newVal < 0) {
          this.nisbah_bagi_hasil_part2 = 0;
        } else {
          this.nisbah_bagi_hasil_part1 = 100 - newVal;
        }
      }
    }
  },
  mounted() {
    this.loadData();
  },
  created() {
    if (this.$store.state.auth.user) {
      this.currentUser = this.$store.state.auth.user;
    }

    if (this.$route.params.id) {
      this.paramsId = this.$route.params.id;
    }
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) return '';
      return 'Rp. ' + parseFloat(value).toLocaleString('id-ID');
    },
    parseCurrency(value) {
      return parseFloat(value.replace(/[^0-9,-]+/g, '').replace(',', '.')) || null;
    },
    async loadData() {
      try {
        this.isLoading = true;
        await this.loadOptionsData();

        if (this.paramsId != null) {
          this.updateSubmit = true;
          await this.loadProductData(this.paramsId);
        }
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async loadProductData(id) {
      try {
        const result = await Product.mitraShow(id);

        if (result.data.meta.code === 200) {
          this.form = result.data.data;

          if (this.form.nisbah) {
            const nisbahParts = this.form.nisbah.split(':');
            this.nisbah_bagi_hasil_part1 = nisbahParts[0];
            this.nisbah_bagi_hasil_part2 = nisbahParts[1];
          }

          this.form.sub_product_category_id = result.data.data.sub_product_category_id;
        } else if (result.data.meta.code === 404) {
          this.showForm = false;
          this.$bvToast.toast('Produk tidak ditemukan. Silakan cek ID produk atau hubungi administrator.', {
            title: 'Produk Tidak Ditemukan',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        } else if (result.data.meta.code === 403) {
          this.showForm = false;
          this.$bvToast.toast('Anda tidak memiliki izin untuk mengakses produk ini.', {
            title: 'Akses Ditolak',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          });
        } else {
          this.showForm = false;
          this.$bvToast.toast('Terjadi kesalahan saat memuat data produk. Silakan coba lagi nanti.', {
            title: 'Kesalahan Server',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        }
      } catch (error) {
        this.showForm = false;
        this.$bvToast.toast('Terjadi kesalahan saat memuat data produk. Silakan coba lagi nanti.', {
          title: 'Kesalahan Server',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
        console.error('Error loading product data:', error);
      }
    },
    async loadOptionsData() {
      try {
        const akadResponse = await AkadSyariah.index();
        this.options.akad = akadResponse.data.data.data.map(item => ({
          value: item.id,
          text: item.name,
        }));

        const subCategoryResponse = await SubProductCategory.index();
        this.options.sub_category = subCategoryResponse.data.data.data.map(item => ({
          value: item.id,
          text: item.name,
          product_category_id: item.product_category_id,
        }));

        const jenisNasabahResponse = await JenisNasabah.index();
        this.options.jenisNasabah = jenisNasabahResponse.data.data.data.map(item => ({
          value: item.id,
          text: item.name,
        }));

        const categoryResponse = await ProductCategory.index();
        this.options.category = categoryResponse.data.data.data.map(item => ({
          value: item.id,
          text: item.name,
        }));

        const mitraTabunganResponse = await Product.index({ mitra: this.currentUser.info.mitra_id, category: 2 });
        this.options.mitra_tabungan = mitraTabunganResponse.data.data.data.map(item => ({
          value: item.id,
          text: item.nama_produk,
        }));
      } catch (error) {
        console.error('Error loading options data:', error);
      }
    },
    validateNisbah() {
      if (this.form.akad_id == 2) {
        return true;
      }
      const totalNisbah = parseInt(this.nisbah_bagi_hasil_part1) + parseInt(this.nisbah_bagi_hasil_part2);

      if (isNaN(totalNisbah)) {
        this.nisbahError = 'Nisbah harus berupa angka.';
        this.scrollToTop();
        return false;
      }

      if (totalNisbah !== 100) {
        this.nisbahError = 'Total Nisbah harus berjumlah 100.';
        this.scrollToTop();
        return false;
      }

      this.nisbahError = '';
      return true;
    },
    validateEqualRate() {
      if (this.form.akad_id == 2) {
        return true;
      }

      if (isNaN(this.form.equal_rate)) {
        this.equalRateError = 'Equal rate harus berupa angka.';
        this.scrollToTop();
        return false;
      }

      if (this.form.equal_rate == null || this.form.equal_rate == 0) {
        this.equalRateError = 'Equal rate harus di isi';
        this.scrollToTop();
        return false;
      }

      if (this.form.equal_rate > 100) {
        this.nisbahError = 'Equal rate maksimal 100%';
        this.scrollToTop();
        return false;
      }

      this.equalRateError = '';
      return true;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    async validateAndAddProduct() {
      this.isLoadSubmit = true;
      try {
        const res = await Product.getIsFillMitraData();
        if (res.data.meta.code !== 200) {
          this.$bvToast.toast('Silakan lengkapi profil Anda terlebih dahulu sebelum menambahkan produk.', {
            title: 'Profil Tidak Lengkap',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          });
          return;
        }

        const resKyc = await Tilaka.checkKycStatus();
        if (resKyc.data.meta.code !== 200) {
          const roleText = resKyc.data.data.sign_role || 'pihak terkait';
          const msg = `Arahkan ${roleText} untuk menyelesaikan proses e-KYC agar bisa menambahkan produk.`;
          this.$bvToast.toast(msg, {
            title: 'Selesaikan e-KYC',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          });
          return;
        }

        const { cer_status, sign_role } = resKyc.data.data;
        if (cer_status == 3) {
          this.addProduct();
        } else {
          const roleText = sign_role || 'pihak terkait';
          this.$bvToast.toast(`Proses e-KYC oleh ${roleText} belum selesai.`, {
            title: 'Selesaikan e-KYC',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          });
        }
      } catch (error) {
        console.error('Terjadi kesalahan saat validasi:', error);
        this.$bvToast.toast('Terjadi kesalahan sistem saat memproses validasi.', {
          title: 'Kesalahan Sistem',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      } finally {
        this.isLoadSubmit = false;
      }
    },
    addProduct() {
      if (!this.validateNisbah()) {
        return;
      }
      if (!this.validateEqualRate()) {
        return;
      }
      this.form.nisbah = `${this.nisbah_bagi_hasil_part1}:${this.nisbah_bagi_hasil_part2}`;
      if (this.form.akad_id == 2) {
        this.form.nisbah = null;
        this.form.equal_rate = null;
      }

      if (this.form.product_category_id != 1) {
        this.form.syarat_kepemilikan_rekening = false;
        this.form.automatic_roll_over = false;
        this.form.penarikan_bagi_hasil = null;
      }

      if (this.form.product_category_id == 1 && this.form.syarat_kepemilikan_rekening != 1) {
        this.form.product_tabungan_id = null;
      }

      this.confirmProductModal = true;
    },
    jenisAkadChange() {
      if (this.form.akad_id == 1) {
        this.disabled = 1;
      } else {
        this.disabled = 0;
        this.nisbah_bagi_hasil_part1 = '';
        this.nisbah_bagi_hasil_part2 = '';
        this.form.nisbah = null;
        this.form.equal_rate = null;
      }
    },
    async confirmAddProduct() {
      this.isLoadSubmit = true;
      this.confirmProductModal = false;

      this.form.mitra_id = this.currentUser.info.mitra_id;

      try {
        const res = await Product.store(this.form);
        if (res.data.meta.code === 200) {
          this.successModal = true;
          this.modalText = 'Produk berhasil dibuat, mohon tunggu persetujuan admin untuk produk tersebut';
        }
      } catch (error) {
        console.error('Error adding product:', error);
      } finally {
        this.isLoadSubmit = false;
      }
    },
    successConfirm() {
      this.$router.push('/dashboard');
    },
    async updateData() {
      try {
        this.isLoadSubmit = true;

        if (!this.validateNisbah()) {
          return;
        }
        if (!this.validateEqualRate()) {
          return;
        }
        if (this.nisbah_bagi_hasil_part1 && this.nisbah_bagi_hasil_part2) {
          this.form.nisbah = `${this.nisbah_bagi_hasil_part1}:${this.nisbah_bagi_hasil_part2}`;
        } else {
          this.form.nisbah = null;
        }
        const data = {
          id: this.form.id,
          mitra_id: this.currentUser.info.mitra_id,
          nama_produk: this.form.nama_produk,
          description: this.form.description,
          product_category_id: this.form.product_category_id,
          sub_product_category_id: this.form.sub_product_category_id,
          akad_id: this.form.akad_id,
          nisbah: this.form.nisbah,
          equal_rate: this.form.equal_rate,
          min_initial_deposit: this.form.min_initial_deposit,
          max_initial_deposit: this.form.max_initial_deposit,
          biaya_administrasi: this.form.biaya_administrasi,
          biaya_dibawah_saldo_minimum: this.form.biaya_dibawah_saldo_minimum,
          biaya_penutupan_rekening: this.form.biaya_penutupan_rekening,
          biaya_penarikan_sebelum_jatuh_tempo: this.form.biaya_penarikan_sebelum_jatuh_tempo,
          keterangan: this.form.keterangan,
          biaya_lain_lain: this.form.biaya_lain_lain,
          jenisnasabah_id: this.form.jenisnasabah_id,
          syarat_kepemilikan_rekening: this.form.syarat_kepemilikan_rekening,
          automatic_roll_over: this.form.automatic_roll_over,
          product_tabungan_id: this.form.product_tabungan_id,
          penarikan_bagi_hasil: this.form.penarikan_bagi_hasil,
          is_publish: 1,
        };

        const res = await Product.update(data);

        if (res.data.meta.code === 200) {
          this.successModal = true;
          this.modalText = 'Produk berhasil diubah, mohon tunggu persetujuan admin untuk produk tersebut';
        }
      } catch (error) {
        console.error('Error updating product:', error);
      } finally {
        this.isLoadSubmit = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/public/dashboard/product-form.vue